import * as React from 'react';

import CampaignTimelineOverviewStep from '../../../step/CampaignTimelineOverviewStep';
import CustomizableTimeline from '../customizable-timeline/CustomizableTimeline';

import { getDisplayDate } from 'utils/date';
import { __t, applyTranslations } from 'utils/language';

import './campaign-overview-timeline.scss';

applyTranslations(require('./campaign-overview-timeline.i18n.json'));

import type {
  CcmCreatorlessCampaignTimeline
} from '../../../../../ccm/types/CcmCampaignTimeline.type';

type Props = {
  timeline: CcmCreatorlessCampaignTimeline
};

const CampaignOverviewTimeline = ({ timeline }: Props): JSX.Element => (
  <div className="campaign-overview-timeline">
    <div className="campaign-overview-timeline__headings">
      <div className="campaign-overview-timeline__heading">
        {__t('campaign_overview_timeline.heading')}
      </div>
    </div>
    <div className="campaign-overview-timeline__body">
      <CustomizableTimeline
        steps={[
          <CampaignTimelineOverviewStep
            key="1"
            value="1"
            type="initial"
            text={__t('campaign_overview_timeline.steps.one')}
            date={`${__t('timeline_estimation.until')} ${getDisplayDate(timeline.taskContentApprovalEndDate)}`}
          />,
          <CampaignTimelineOverviewStep
            key="2"
            value="2"
            type="common"
            text={__t('campaign_overview_timeline.steps.two')}
            date={getDisplayDate(timeline.taskContentGoLiveDate)}
          />,

          <CampaignTimelineOverviewStep
            key="3"
            value="3"
            type="final"
            text={__t('campaign_overview_timeline.steps.three')}
            date={getDisplayDate(timeline.campaignEndDate)}
          />
        ]}
      />
    </div>
  </div>
);

export default CampaignOverviewTimeline;
